import { TutorMessage } from '@homework-app/shared';
import './ChatMessage.css';

interface ChatMessageProps {
  message: TutorMessage;
  apiBase: string;
}

export default function ChatMessage({ message, apiBase }: ChatMessageProps) {
  const isUser = message.role === 'user';

  // Parse image URL - handle both relative and blob URLs
  const getImageUrl = (url: string | null | undefined) => {
    if (!url) return null;
    if (url.startsWith('blob:')) return url;
    if (url.startsWith('/')) return `${apiBase.replace('/api', '')}${url}`;
    return url;
  };

  const imageUrl = getImageUrl(message.image_url);

  return (
    <div className={`chat-message ${isUser ? 'user' : 'assistant'}`}>
      <div className="message-avatar">
        {isUser ? 'You' : 'AI'}
      </div>
      <div className="message-content">
        {imageUrl && (
          <div className="message-image">
            <img src={imageUrl} alt="Homework" />
          </div>
        )}
        <div className="message-text">{message.content}</div>
        <div className="message-time">
          {new Date(message.created_at).toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
          })}
        </div>
      </div>
    </div>
  );
}
